import React from 'react'
import Link from 'gatsby-link'
import Artist from '../components/artist'
import { css } from 'glamor'

let artistContainer = css({
  paddingBottom: '50px',
})

let artistRow = css({
  margin: '40px 0 10px 20px',
  display: 'inline-flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
})

const Artists = () => (
  <div className={artistContainer}>
    <div className={artistRow}>
        <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/12x12_press_photo.jpg"
                name="12 x 12"
                sc_url="https://soundcloud.com/12x12" />
        <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/lestasi_press_photo.jpg"
                name="L'estasi Dell'oro"
                sc_url="https://soundcloud.com/lestasi-delloro" />
        <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/nconduit_press_photo.jpg"
                name="N'conduit"
                sc_url="https://soundcloud.com/nconduit" />
    </div>

    <div className={artistRow}>
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/antonzap_press_photo.jpg"
              name="AntonZap"
              sc_url="https://soundcloud.com/antonzap" />
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/beaner_press_photo.jpg"
              name="Beaner"
              sc_url="https://soundcloud.com/beaner" />
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/bls_press_photo.jpg"
              name="Black Light Smoke"
              sc_url="https://soundcloud.com/black-light-smoke" />
    </div>

    <div className={artistRow}>
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/deadbeat_press_photo.jpg"
              name="Deadbeat"
              sc_url="https://soundcloud.com/deadbeat" />
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/maddermodes_press_photo.jpg"
              name="MadderModes"
              sc_url="https://soundcloud.com/maddermodes" />
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/october_press_photo.jpg"
              name="October"
              sc_url="https://soundcloud.com/october" />
    </div>

    <div className={artistRow}>
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/omf_press_photo.jpg"
              name="Our Mutual Friend"
              sc_url="https://soundcloud.com/ourmutualfriendmusic" />
      <Artist img_url="http://vdr.s3.amazonaws.com/site_assets/stl_press_photo.jpg"
              name="STL"
              sc_url="http://www.something-records.com/" />
    </div>
  </div>
)

export default Artists



// WEBPACK FOOTER //
// ./src/pages/artists.js